import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.map";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.number.constructor";
import "core-js/modules/es.string.includes";
import "core-js/modules/web.dom-collections.for-each";
import "regenerator-runtime/runtime";
import _asyncToGenerator from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _objectSpread from "/root/workspace/admin_admin-web_uLO7/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { createStationCheck } from '@/api/bairun/oilpsiManage'; //  此处请自行替换地址

import { getStationOilTankInfoList } from '@/api/bairun/stationOilTankInfo';
import { formatTimeToStr } from '@/utils/date';
import infoList from '@/mixins/infoList';
import { mapGetters } from 'vuex';

var _this;

export default {
  name: 'BairunStationCheckAdd',
  components: {},
  computed: _objectSpread({}, mapGetters('stations', ['asyncStations'])),
  filters: {
    formatDate: function formatDate(time) {
      if (time != null && time !== '') {
        var date = new Date(time);
        return formatTimeToStr(date, 'yyyy-MM-dd hh:mm:ss');
      } else {
        return '';
      }
    },
    formatBoolean: function formatBoolean(bool) {
      if (bool != null) {
        return bool ? '是' : '否';
      } else {
        return '';
      }
    },
    getSellerShortName: function getSellerShortName(ID) {
      if (ID == 0) {
        return '总';
      }

      for (var i = 0; i < _this.asyncStations.length; i++) {
        if (_this.asyncStations[i].ID === ID) {
          return _this.asyncStations[i].statAbbr;
        }
      }

      return '';
    },
    getSellerName: function getSellerName(ID) {
      if (ID == 0) {
        return '总';
      }

      for (var i = 0; i < _this.asyncStations.length; i++) {
        if (_this.asyncStations[i].ID === ID) {
          return _this.asyncStations[i].stationName;
        }
      }

      return '';
    }
  },
  mixins: [infoList],
  data: function data() {
    return {
      title: '',
      tankList: [],
      formData: {}
    };
  },
  beforeCreate: function beforeCreate() {
    _this = this;
  },
  activated: function activated() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  created: function created() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
      return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _this.formData = _this2.initData();
              _this.title = _this.$route.params.meta.title;

            case 2:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }))();
  },
  methods: {
    initData: function initData() {
      return {
        stationId: '',
        dailyDate: '',
        rows: []
      };
    },
    // 解决input无法输入问题
    inputChange: function inputChange() {
      this.$forceUpdate();
    },
    onClear: function onClear() {
      this.formData = this.initData();
    },
    onChangeStation: function onChangeStation() {
      var _this3 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var res;
        return regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _this3.tankList = [];
                _this3.formData.rows = [];
                _context3.next = 4;
                return getStationOilTankInfoList({
                  stationId: _this3.formData.stationId,
                  page: 1,
                  pageSize: 999999,
                  dataType: 'simpleFields'
                });

              case 4:
                res = _context3.sent;
                res.data.list.forEach(function (item) {
                  _this3.tankList.push({
                    'oilTankNo': item.oilTankNo,
                    'tankNum': item.tankNum,
                    'oilCode': item.oilCode,
                    'tankHeightStatus': item.tankHeightStatus
                  });
                });

                _this3.onAddRow(true);

                _this3.$forceUpdate();

              case 8:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3);
      }))();
    },
    onAddRow: function onAddRow() {
      var _this4 = this;

      var isAddAll = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

      if (this.formData.rows.length === this.tankList.length) {
        return;
      }

      var oilTankNoArr = this.formData.rows.map(function (item) {
        return item.oilTankNo;
      });
      var canAddTankList = this.tankList.filter(function (item) {
        return !oilTankNoArr.includes(item.oilTankNo);
      });

      if (canAddTankList.length) {
        if (isAddAll === true) {
          canAddTankList.forEach(function (item) {
            _this4.formData.rows.push({
              'oilTankNo': item.oilTankNo,
              'tankNum': item.tankNum,
              'oilCode': item.oilCode,
              'tankHeightStatus': item.tankHeightStatus,
              'tankAdjustLiters': '',
              sequenceOilHeight: '',
              sequenceWaterHeight: '',
              sequenceWaterCapacity: '',
              sequenceOilCapacity: '',
              measureOilHeight: '',
              measureWaterHeight: '',
              measureWaterCapacity: '',
              measureOilCapacity: ''
            });
          });
        } else {
          this.formData.rows.push({
            'oilTankNo': canAddTankList[0].oilTankNo,
            'tankNum': canAddTankList[0].tankNum,
            'oilCode': canAddTankList[0].oilCode,
            'tankHeightStatus': canAddTankList[0].tankHeightStatus,
            'tankAdjustLiters': '',
            sequenceOilHeight: '',
            sequenceWaterHeight: '',
            sequenceWaterCapacity: '',
            sequenceOilCapacity: '',
            measureOilHeight: '',
            measureWaterHeight: '',
            measureWaterCapacity: '',
            measureOilCapacity: ''
          });
        }
      }
    },
    onDelRow: function onDelRow(index) {
      this.formData.rows.splice(index, 1);
    },
    onSave: function onSave() {
      var _this5 = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var res;
        return regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (_this5.formData.stationId) {
                  _context4.next = 3;
                  break;
                }

                _this5.$message({
                  type: 'warning',
                  message: '油站不能为空！'
                });

                return _context4.abrupt("return");

              case 3:
                if (_this5.formData.dailyDate) {
                  _context4.next = 6;
                  break;
                }

                _this5.$message({
                  type: 'warning',
                  message: '日期不能为空！'
                });

                return _context4.abrupt("return");

              case 6:
                _this5.formData.rows.forEach(function (item) {
                  item.dailyDate = Number(_this5.formData.dailyDate);
                });

                _context4.next = 9;
                return createStationCheck({
                  'stationId': _this5.formData.stationId,
                  'sequenceList': _this5.formData.rows
                });

              case 9:
                res = _context4.sent;

                if (res.code == 0) {
                  _this5.$message({
                    type: 'success',
                    message: '操作成功！'
                  });

                  setTimeout(function () {
                    _this5.goBack();
                  }, 300);
                }

              case 11:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4);
      }))();
    }
  }
};